import React, { useEffect } from 'react';
import { META_DESCRIPTION, META_PIXEL_ID, PAGE_TITLE, bonusCovers, heroMockupUrl, offerMockupUrl, pageImages } from './data/content';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBand } from './components/StatsBand';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { FeaturesSection } from './components/FeaturesSection';
import { SermonsSection } from './components/SermonsSection';
import { LookInsideSection } from './components/LookInsideSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalChoiceSection } from './components/FinalChoiceSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
const pixelNoscript = `<img height="1" width="1" style="display:none" alt="" src="https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1" />`;
export function App() {
  useEffect(() => {
    document.title = PAGE_TITLE;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = META_DESCRIPTION;
    initMetaPixel();
  }, []);
  return <div id="top" className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-ink antialiased" data-id="element-0" data-mp="38l04bxqkep5n">
      <noscript dangerouslySetInnerHTML={{
      __html: pixelNoscript
    }} data-id="element-1" data-mp="3dmfprqwnmxok" />
      <TopBar data-id="element-2" data-mp="nwc39wy9i3yd" />
      <main data-id="element-3" data-mp="nuhjilyq8hvv">
        <Hero heroMockupUrl={heroMockupUrl} data-id="element-4" data-mp="nv0xjrl9am4m" />
        <StatsBand data-id="element-5" data-mp="sudl6ejybx89" />
        <PainSection data-id="element-6" data-mp="stufbw7kszal" />
        <SolutionSection data-id="element-7" data-mp="stc7017n2umb" />
        <FeaturesSection data-id="element-8" data-mp="swqajcs1h9vc" />
        <SermonsSection data-id="element-9" data-mp="3684vetzoctf" />
        <LookInsideSection pageImages={pageImages} data-id="element-10" data-mp="35gkz19r83iz" />
        <BonusesSection bonusCovers={bonusCovers} data-id="element-11" data-mp="38b6yx8f1wei" />
        <OfferSection offerMockupUrl={offerMockupUrl} data-id="element-12" data-mp="3ubri4mbn8k51" />
        <GuaranteeSection data-id="element-13" data-mp="d4nvzht0nm2x" />
        <FaqSection data-id="element-14" data-mp="d4xopd5g47cb" />
        <FinalChoiceSection data-id="element-15" data-mp="d3cwhu6lt0hm" />
      </main>
      <Footer data-id="element-16" data-mp="d2bfl92wpjrz" />
      <StickyCta data-id="element-17" data-mp="85uktw17c75x" />
    </div>;
}